/**
 * ProjectChangeRequestsView — `/projects/$projectId/change-requests`
 *
 * Placeholder honesto del tab "Solicitudes de cambio". El backend de
 * Change Requests + análisis de impacto + agentes IA llega en Fase E
 * del roadmap. Hasta entonces, este tab muestra:
 *  - Header con eyebrow "Pendiente · Fase E".
 *  - Subtitle explicativo.
 *  - Preview list de las 5 capacidades que traerá la pantalla.
 *  - Nota final aclarando que es placeholder.
 *
 * NO mostramos data fake — la promesa es honestidad: si no hay backend,
 * no inventamos números.
 */

import { useTranslation } from 'react-i18next'
import {
  Check,
  GitFork,
  History,
  Send,
  ShieldCheck,
  Sparkles,
} from 'lucide-react'

import { ScrollPage } from '../../components/shell/ScrollPage'

export function ProjectChangeRequestsView() {
  const { t } = useTranslation('projects')

  return (
    <ScrollPage padding="tight">
      <div className="max-w-3xl">
      <header className="mb-6">
        <p className="text-[10px] uppercase tracking-wider font-semibold text-ink-subtle mb-1">
          {t('change_requests.header_eyebrow')}
        </p>
        <h2 className="font-display text-2xl font-semibold text-ink">
          {t('change_requests.header_title')}
        </h2>
        <p className="mt-2 font-body text-sm text-ink-muted">
          {t('change_requests.header_subtitle')}
        </p>
      </header>

      <article className="bg-surface border border-line rounded-md p-6">
        <h3 className="font-display text-lg text-ink mb-4">
          {t('change_requests.preview.title')}
        </h3>
        <ul className="space-y-3 font-body text-sm">
          <PreviewItem
            icon={Send}
            text={t('change_requests.preview.items.create')}
          />
          <PreviewItem
            icon={Sparkles}
            text={t('change_requests.preview.items.impact')}
          />
          <PreviewItem
            icon={Check}
            text={t('change_requests.preview.items.review')}
          />
          <PreviewItem
            icon={ShieldCheck}
            text={t('change_requests.preview.items.publish')}
          />
          <PreviewItem
            icon={History}
            text={t('change_requests.preview.items.history')}
          />
        </ul>
      </article>

      <div className="mt-5 flex items-start gap-2 text-xs text-ink-subtle">
        <GitFork className="w-3.5 h-3.5 mt-0.5 shrink-0" />
        <p className="font-body italic">
          {t('change_requests.phase_e_note')}
        </p>
      </div>
      </div>
    </ScrollPage>
  )
}

function PreviewItem({
  icon: Icon,
  text,
}: {
  icon: typeof Check
  text: string
}) {
  return (
    <li className="flex items-start gap-3">
      <span className="w-7 h-7 rounded-md bg-brand-soft text-brand grid place-items-center shrink-0 mt-0.5">
        <Icon className="w-3.5 h-3.5" />
      </span>
      <span className="text-ink-muted">{text}</span>
    </li>
  )
}
